import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Manifesto } from "@/components/site/Manifesto";
import { Services } from "@/components/site/Services";
import { VideoProduction } from "@/components/site/VideoProduction";
import { Portfolio } from "@/components/site/Portfolio";
import { SocialProjects } from "@/components/site/SocialProjects";
import { Stats } from "@/components/site/Stats";
import { Team } from "@/components/site/Team";
import { Testimonials } from "@/components/site/Testimonials";
import { BookingCTA } from "@/components/site/BookingCTA";
import { ContactForm } from "@/components/site/ContactForm";
import { Contact } from "@/components/site/Contact";

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <Services />
        <VideoProduction />
        <Portfolio />
        <SocialProjects />
        <Stats />
        <Team />
        <Testimonials />
        <BookingCTA />
        <ContactForm />
        <Contact />
      </main>
    </>
  );
}
